import React, {useEffect} from "react"
import "./custom.scss"
import "./App.scss"
import {Navigate, Route, Routes} from "react-router-dom"

import {useTheme} from "./context/ThemeProvider"
import ErrorComponent from "./components/Error/ErrorComponent"
import AdminDashboardComponent from "./components/Admin/BookingCalendarComponent/BookingCalendarComponent"
import BookingComponent from "./components/Booking/BookingComponent"
import ExamSelectComponent from "./components/ExamSelection/ExamSelectComponent"
import SettingsComponent from "./components/Settings/SettingsComponent"
import StartComponentFixed from "./components/Start/StartComponent"
import InfoComponent from "./components/InfoView/InfoComponent"
import FAQComponent from "./components/FAQ/FAQComponent"
import BookingInfoComponent from "./components/Booking/BookingInfoComponent"
import momenttz from "moment-timezone"
import DepartureComponent from "./components/Departure/DepartureComponent"

import moment from "moment"
import "moment/locale/de"
import {useTranslation} from "react-i18next"
import BookingDistributionComponent from "./components/BookingDistribution/BookingDistributionComponent"
import UserManagementComponent from "./components/Admin/UserManagementComponent/UserManagementComponent"
import SiteInfoComponent from "./components/InfoView/SiteInfoComponent"
import BuildingsDebugViewComponent from "./components/Admin/RolloutBuildingsDebugViewComponent/BuildingsDebugViewComponent"
import PublicRoute from "./components/Helper/PublicRoute/PublicRoute"
import ProtectedRoute from "./components/Helper/ProtectedRoute/ProtectedRoute"
import ExamPasterComponent from "./components/Admin/ExamPasterComponent/ExamPasterComponent"
import PhotoIdGuideComponent from "./components/Admin/PhotoIdGuideComponent/PhotoIdGuideComponent"
import TenantOverview from "./components/Tenant/TenantOverview"
import AppLayout from "./components/Navigation/AppLayout"
import EexamAdminView from "./components/Eexam/EexamAdminView"
import ParticipantView from "./components/exam-management/ParticipantView";
import ExamManagementComponent from "./components/exam-management/ExamManagementComponent";
import ExecutingTenantView from "./components/exam-management/ExecutingTenantView";
import ExamAccessView from "./components/exam-management/ExamAccessView";
import TenantTreeComponent from "./components/Admin/debug/TenantTreeComponent";
import SchedulerAdminComponent from "./components/Admin/SchedulerAdminComponent"
import RoomManagementComponent from "./components/Admin/RoomManagementComponent"
import EvaluationManagementComponent from "./components/Admin/EvaluationManagementComponent"
import TestMailManagementComponent from "./components/Admin/TestMailManagementComponent"
import MailQueueComponent from "./components/Admin/MailQueueComponent"
import ExamStatisticsComponent from "./components/Statistics/ExamStatisticsComponent"
import TucanExamRoomsComponent from "./components/Admin/TucanExamRoomsComponent"
import TucanMinerStatusComponent from "./components/Admin/TucanMinerStatusComponent"
import TucanCachedExamsComponent from "./components/Admin/TucanCachedExamsComponent"
import TucanExamArchiveComponent from "./components/Admin/TucanExamArchiveComponent"
import RoomPowerPlanningComponent from "./components/Admin/RoomPowerPlanningComponent"

function App() {
    const {i18n} = useTranslation()
    const theme = useTheme()

    i18n.on("languageChanged", () => {
        moment.locale(i18n.language)
        document.documentElement.lang = i18n.language
    })

    moment.locale(i18n.language)
    document.documentElement.lang = i18n.language

    useEffect(() => {
        document.body.style.backgroundImage = "url('/athenebg_" + theme.getTheme() + ".svg')"
        document.body.style.backgroundSize = "cover"
        momenttz.tz.setDefault("Europe/Berlin")
    }, [theme])

    return (
        <Routes>
            <Route element={<AppLayout />}>
                <Route path="/" element={<PublicRoute><InfoComponent /></PublicRoute>} />
                <Route path="/faq" element={<PublicRoute><FAQComponent /></PublicRoute>} />
                <Route path="/climate/6784d8aeb2e2dd156850e00a" element={<PublicRoute><SiteInfoComponent /></PublicRoute>} />
                <Route path="/error" element={<PublicRoute><ErrorComponent msg="" /></PublicRoute>} />

                <Route path="/admin/calendar" element={<ProtectedRoute><AdminDashboardComponent /></ProtectedRoute>} />
                <Route path="/admin/users" element={<ProtectedRoute><UserManagementComponent /></ProtectedRoute>} />
                <Route path="/admin/buildings" element={<ProtectedRoute><BuildingsDebugViewComponent /></ProtectedRoute>} />
                <Route path="/admin/debug/exampaster" element={<ProtectedRoute><ExamPasterComponent /></ProtectedRoute>} />
                <Route path="/admin/debug/photo-id-guide" element={<ProtectedRoute><PhotoIdGuideComponent /></ProtectedRoute>} />
                <Route path="/admin/schedulers" element={<ProtectedRoute><SchedulerAdminComponent /></ProtectedRoute>} />
                <Route path="/admin/tucan-exam-rooms" element={<ProtectedRoute><TucanExamRoomsComponent /></ProtectedRoute>} />
                <Route path="/admin/tucan-miner" element={<ProtectedRoute><TucanMinerStatusComponent /></ProtectedRoute>} />
                <Route path="/admin/tucan-cached-exams" element={<ProtectedRoute><TucanCachedExamsComponent /></ProtectedRoute>} />
                <Route path="/admin/tucan-exam-archive" element={<ProtectedRoute><TucanExamArchiveComponent /></ProtectedRoute>} />
                <Route path="/admin/room-power-planning" element={<ProtectedRoute><RoomPowerPlanningComponent /></ProtectedRoute>} />
                <Route path="/admin/room-power-planning/:roomId" element={<ProtectedRoute><RoomPowerPlanningComponent /></ProtectedRoute>} />
                <Route path="/admin/room-power-planning/:roomId/edit" element={<ProtectedRoute><RoomPowerPlanningComponent /></ProtectedRoute>} />
                <Route path="/admin/rooms" element={<ProtectedRoute><RoomManagementComponent /></ProtectedRoute>} />
                <Route path="/admin/evaluations" element={<ProtectedRoute><EvaluationManagementComponent /></ProtectedRoute>} />
                <Route path="/admin/test-mails" element={<ProtectedRoute><TestMailManagementComponent /></ProtectedRoute>} />
                <Route path="/admin/mail-queue" element={<ProtectedRoute><MailQueueComponent /></ProtectedRoute>} />
                <Route path="/statistics" element={<ProtectedRoute><ExamStatisticsComponent /></ProtectedRoute>} />

                <Route path="/booking/:id" element={<ProtectedRoute><BookingComponent /></ProtectedRoute>} />
                <Route path="/selectExam" element={<ProtectedRoute><ExamSelectComponent /></ProtectedRoute>} />
                <Route
                    path="/exam-management"
                    element={<ExamManagementComponent/>}
                />

                <Route
                    path="/exam-management/:examId/participants"
                    element={<ParticipantView/>}
                />

                <Route
                    path="/exam-management/:examId/executing-tenants"
                    element={<ExecutingTenantView/>}
                />

                <Route
                    path="/exam-management/:examId/access"
                    element={<ExamAccessView/>}
                />
                <Route
                    path="/exam-management/:examId/tenants"
                    element={<ExecutingTenantView/>}
                />

                <Route
                    path="/admin/debug/tenanttree"
                    element={<TenantTreeComponent/>}
                />
                <Route path="/bookingDistribution/:id" element={<ProtectedRoute><BookingDistributionComponent /></ProtectedRoute>} />
                <Route path="/settings" element={<ProtectedRoute><SettingsComponent /></ProtectedRoute>} />
                <Route path="/bookingInfo/:id" element={<ProtectedRoute><BookingInfoComponent /></ProtectedRoute>} />
                <Route path="/booking" element={<ProtectedRoute><StartComponentFixed /></ProtectedRoute>} />
                <Route path="/departures" element={<ProtectedRoute><DepartureComponent /></ProtectedRoute>} />
                <Route path="/tenants" element={<ProtectedRoute><TenantOverview /></ProtectedRoute>} />

                <Route path="/faq/:debug" element={<ProtectedRoute><FAQComponent /></ProtectedRoute>} />
                <Route path="/climate/:siteId" element={<ProtectedRoute><SiteInfoComponent /></ProtectedRoute>} />
                <Route path="/eexams" element={<ProtectedRoute><EexamAdminView /></ProtectedRoute>} />

                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
        </Routes>
    )
}

export default App
